import {Button, Flex, Modal, Text} from '@mantine/core'
import {useState} from 'react'
import type {Connection} from '@package/shared'
import {AddForm as AddIcalSubscriptionForm} from '../forms/ical/AddForm.tsx'
import {AddForm as AddGitHubForm} from '../forms/github/AddForm.tsx'
import {AddForm as AddJiraForm} from '../forms/jira/AddForm.tsx'
import {ConnectionTypeIcon} from '../../calendar/components/icons/ConnectionTypeIcon.tsx'

type Props = {
  opened: boolean
  onClose: () => void
}

const connectionTypes = ['ical-subscription', 'github-api', 'jira-api'] satisfies Connection['type'][]

export const AddConnectionModal = ({opened, onClose}: Props) => {
  const [connectionType, setConnectionType] = useState<Connection['type']>()
  if (!opened && connectionType !== undefined) {
    setConnectionType(undefined)
  }

  return (
    <Modal opened={opened} onClose={onClose} title={'Add connection'} size={'lg'}>
      <Flex direction={'column'} gap={'sm'}>
        {!connectionType &&
          connectionTypes.map((type) => (
            <Button
              key={type}
              variant={'default'}
              size={'xl'}
              leftSection={<ConnectionTypeIcon type={type} size={24} />}
              onClick={() => setConnectionType(type)}
            >
              <Text size={'lg'}>
                {
                  {
                    'ical-subscription': 'Calendar',
                    'github-api': 'GitHub',
                    'jira-api': 'Jira',
                  }[type]
                }
              </Text>
            </Button>
          ))}

        {connectionType === 'ical-subscription' && <AddIcalSubscriptionForm onSuccess={onClose} disabled={false} />}
        {connectionType === 'github-api' && <AddGitHubForm onSuccess={onClose} disabled={false} />}
        {connectionType === 'jira-api' && <AddJiraForm onSuccess={onClose} disabled={false} />}
      </Flex>
    </Modal>
  )
}
